module.exports = __webpack_public_path__ + "static/media/black_word_count.2a4a3310.svg";